import { t } from 'i18next'
import { getStartNode, openCustomInputDialog } from './customInputHelpers'

const getCurrentLineHeight = (editor: Editor): string => {
  const node = getStartNode(editor)
  const block = editor.dom.getParent(node, editor.dom.isBlock) || node
  const element = block as Element

  const inlineLineHeight = editor.dom.getStyle(element, 'line-height')
  if (inlineLineHeight) return inlineLineHeight

  const computed = window.getComputedStyle(element)
  const computedLineHeight = computed.lineHeight

  if (computedLineHeight === 'normal') return ''

  if (computedLineHeight?.endsWith('px')) {
    const lhPx = parseFloat(computedLineHeight)
    const fsPx = parseFloat(computed.fontSize)
    if (!isNaN(lhPx) && !isNaN(fsPx) && fsPx > 0) {
      const ratio = Math.round((lhPx / fsPx) * 100) / 100
      return `${ratio}`
    }
  }

  return computedLineHeight || ''
}

export const registerCustomLineSpacePlugin = ({
  editor,
}: {
  editor: Editor
}) => {
  editor.ui.registry.addButton('customLineSpace', {
    icon: 'kebab',
    tooltip: t('editor.tinyMCE.customLineSpace.tooltip'),
    onAction: () => {
      const currentLineHeight = getCurrentLineHeight(editor)

      openCustomInputDialog({
        editor,
        translationKey: 'customLineSpace',
        inputName: 'lineSpace',
        placeholder: '1.5',
        initialValue: currentLineHeight,
        validation: {
          maxIntegers: 2,
          maxDecimals: 2,
          min: 0.01,
          max: 99.99,
        },
        onValidSubmit: (value) => {
          editor.execCommand('LineHeight', false, `${value}`)
        },
      })
    },
  })
}
